import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

const LazyToaster = lazy(() => import("@/components/ui/toaster").then(m => ({ default: m.Toaster })));
const LazySonner = lazy(() => import("@/components/ui/sonner").then(m => ({ default: m.Toaster })));
const LazyTooltipProvider = lazy(() => import("@/components/ui/tooltip").then(m => ({ default: m.TooltipProvider })));

import Index from "./pages/Index";
const Tratamentos = lazy(() => import("./pages/Tratamentos"));
const EnsinoCursos = lazy(() => import("./pages/EnsinoCursos"));
const CursoHarmonizacaoIntima = lazy(() => import("./pages/CursoHarmonizacaoIntima"));
const Profissionais = lazy(() => import("./pages/Profissionais"));
const TVIbiomed = lazy(() => import("./pages/TVIbiomed"));
const ProjetoSocial = lazy(() => import("./pages/ProjetoSocial"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <Suspense fallback={null}>
      <LazyTooltipProvider>
        <LazyToaster />
        <LazySonner />
      </LazyTooltipProvider>
    </Suspense>
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/tratamentos" element={<Tratamentos />} />
          <Route path="/ensino-cursos" element={<EnsinoCursos />} />
          <Route path="/ensino-cursos/harmonizacao-intima" element={<CursoHarmonizacaoIntima />} />
          <Route path="/profissionais" element={<Profissionais />} />
          <Route path="/tv-ibiomed" element={<TVIbiomed />} />
          <Route path="/projeto-social" element={<ProjetoSocial />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </QueryClientProvider>
);

export default App;
